<template>
    <div>
        <BodyBlog/>
    </div>
</template>

<script>
import BodyBlog from "../components/BodyBlog.vue"

export default {
    components:{
        BodyBlog
    }
}
</script>